var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6399 18.5599H17.3199L17.7199 13.0399V7.2799H14.2799V13.0399L14.6399 18.5599ZM0.399902 15.9999C0.399902 24.7199 7.2799 31.5999 15.9999 31.5999C24.7599 31.5999 31.5999 24.4799 31.5999 15.9999C31.5999 7.2799 24.7199 0.399902 15.9999 0.399902C7.2799 0.399902 0.399902 7.2799 0.399902 15.9999ZM3.5999 15.9999C3.5999 9.0399 9.0399 3.5999 15.9999 3.5999C22.9599 3.5999 28.3999 9.0399 28.3999 15.9999C28.3999 22.7599 22.9599 28.3999 15.9999 28.3999C9.0399 28.3999 3.5999 22.9599 3.5999 15.9999ZM14.0799 24.7999H17.9199V20.9599H14.0799V24.7999Z",
    fill: "#FF895A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeExclamationIcon);
export default __webpack_public_path__ + "static/media/orange-exclamation-icon.567bf7bed8ed55ca3ae489c3d7ae11a9.svg";
export { ForwardRef as ReactComponent };